<template>
    <div class="slack-message-editor">
        <slack-editor
            ref="editor"
            @escape="escape_handler"
            @input="editor_input_handler"
            @keydown="keydown_handler"
            @keyup="keyup_handler"
            @submit="submit"
            @submit_button="handle_submit_button"
            @tab="select_item_handler"
            @selected_emoji="handle_add_emoji"
        />
        <div
            class="slack-popup"
            :style="popup_style"
            v-show="show_popup"
        >
            <div
                class="slack-popup-body"
                ref="popup_body"
            >
                <ul class="slack-autocomplete-results">
                    <li
                        v-for="(user, key) in filtered_users"
                        :class="[
                            'slack-result-item',
                            { 'slack-selected-item': key === selected },
                        ]"
                        :key="`result-item-${key}`"
                        :ref="`result_item_${key}`"
                        @click="handle_item_click"
                        @mouseenter="selected = key"
                    >
                        <div class="slack-base-item">
                            <span class="slack-avatar">
                                <img
                                    :src="user.profile.image_48"
                                    alt="avatar"
                                />
                            </span>
                            <div class="slack-text-contents">
                                <span class="slack-name">
                                    <strong>
                                        {{ user.name }}
                                    </strong>
                                </span>
                                <span class="slack-secondary-name">
                                    {{ user.real_name }}
                                </span>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <!-- <div
            class="test"
            ref="console"
            style="height: 300px; width: 100%"
        ></div> -->
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { list_users, post_message, } from '../../slack_api'
import { build_message, get_caret_pixel_pos, get_popup_search_term, get_text_until_caret, insert_emoji, insert_mention } from './editor_utils'
import SlackEditor from './SlackEditor.vue'
export default {
    components: { SlackEditor },
    computed: {
        ...mapGetters([
            'slack_channels',
            'slack_users',
        ]),
        channel_name() {
            const channel = (this.slack_channels || []).find(ch => ch.id === this.$route.params.id)
            return channel && (!channel.is_im && channel.name || channel.user_info.real_name) || ''
        },
        editor() {
            return this.$refs.editor.editor
        },
        show_placeholder() {
            return this.text === ''
        },
    },
    data() {
        return {
            filtered_users: [],
            popup_style: { transform: 'translate(-32px,-100%)' },
            previous_text: '',
            range: null,
            search_term: '',
            selected: 0,
            show_popup: false,
            text: '',
            users: [],
        }
    },
    methods: {
        editor_input_handler(e) {
            const pos = get_caret_pixel_pos(e.target),
                text = get_text_until_caret(e.target)
            this.range = window.getSelection().getRangeAt(0)
            if (e.data === null && this.text.replace(text, '') === '@') {
                this.show_popup = false
            }
            if (e.data === '@' && !this.show_popup) {
                this.search_term = ''
                this.filtered_users = [...this.slack_users]
                if (pos) {
                    this.popup_style = { ...this.popup_style, ...pos }
                    this.show_popup = true
                }
            } else if (this.show_popup) {
                this.search_term = get_popup_search_term(e.target)
                this.search_users()
            }
            this.text = text
        },
        escape_handler(e) {
            if (!this.show_popup) {
                return
            }
            this.stop_popup()
        },
        handle_add_emoji(data) {
            this.editor.focus()
            this.$nextTick(() => {
                window.getSelection().removeAllRanges()
                const editor = this.editor
                insert_emoji(data, editor, this.search_term)
            })
        },
        handle_item_click(e) {
            this.editor.focus()
            window.getSelection().removeAllRanges()
            window.getSelection().addRange(this.range)
            this.select_item_handler({
                preventDefault() { },
                target: this.editor,
            })
        },
        keydown_handler(e) {
            this.keymove(e, 'down')
        },
        keymove(e, direction) {
            if (!this.show_popup) {
                return
            }
            e.preventDefault()
            let inc = 1
            const l = this.filtered_users.length
            switch (direction) {
                case 'up':
                    inc = -1
                    if (this.selected === 0) {
                        inc = l - 1
                    }
                    break
            }
            if (l) {
                this.selected = (this.selected + inc) % l
                const item_array = this.$refs[`result_item_${this.selected}`],
                    item = item_array && item_array.length > 0 && item_array[0] || null,
                    popup_body = this.$refs.popup_body
                if (item && item.offsetTop + item.offsetHeight > popup_body.scrollTop + popup_body.offsetHeight) {
                    popup_body.scrollTo(0, item.offsetTop - popup_body.offsetHeight + item.offsetHeight)
                } else if (item && item.offsetTop < popup_body.scrollTop) {
                    popup_body.scrollTo(0, item.offsetTop)
                }
            }
        },
        keyup_handler(e) {
            this.keymove(e, 'up')
        },
        search_users: _.debounce(function () {
            this.filtered_users = this.slack_users.filter(user => {
                const reg_exp = new RegExp(`^.*${this.search_term}.*$`, 'gi')
                return reg_exp.test(user.name) || reg_exp.test(user.real_name)
            })
            this.filtered_users.length && (this.selected = 0)
        }, 350),
        select_item_handler(e) {
            if (!this.show_popup) {
                return
            }
            e.preventDefault()
            const editor = e.target,
                user = this.filtered_users[this.selected]
            insert_mention(user, editor, this.search_term)
            this.stop_popup()
        },
        stop_popup() {
            this.filtered_users = [...this.slack_users]
            this.search_term = ''
            this.show_popup = false
        },
        handle_submit_button() {
            this.submit({ preventDefault() { }, target: this.editor })
        },
        submit(e) {
            if (this.show_popup) {
                this.select_item_handler(e)
                return
            }
            const channel = this.$route.params.id || this.$route.params.selected_id

            const editor = e.target

            const editor_clone = editor.cloneNode(true)

            const message = build_message(editor_clone, channel)

            if (this.thread_ts) {
                message.thread_ts = this.thread_ts
            }
            post_message(message).then(data => {
                this.$emit('message', data.message)
              setTimeout(() => {
                $('.slack-chat').animate({scrollTop: $(".slack-chat")[0].scrollHeight},"fast");
              }, 500)
                editor.innerHTML = ''
            })
            e.preventDefault()
        },
    },
    mounted() {
        this.slack_users.length === 0 && list_users()
    },
    props: ['thread_ts'],
}
</script>
<style>
.slack-message-editor {
  position: relative; }

.slack-message-editor .slack-popup {
  background-color: lightblue;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  line-height: 1.4rem;
  max-height: 220px;
  max-width: 540px;
  overflow: hidden;
  position: absolute; }

.slack-message-editor .slack-popup .slack-popup-body {
  overflow: hidden auto;
  padding: 8px 0; }

.slack-message-editor .slack-popup .slack-autocomplete-results > li.slack-result-item {
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 32px;
  margin: 0; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item {
  background-color: #1264a3; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item .slack-base-item {
  align-items: center;
  display: flex;
  height: 100%;
  line-height: 20px;
  padding: 0 16px;
  width: 100%; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item .slack-avatar {
  height: 20px;
  margin-right: 8px;
  width: 20px; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item .slack-avatar img {
  border-radius: 4px;
  height: 20px;
  width: 20px; }

.slack-text-contents {
  display: flex;
  word-break: break-all; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item .slack-name {
  display: -webkit-box;
  margin-right: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; }

.slack-message-editor .slack-popup .slack-selected-item > .slack-base-item .slack-secondary-name {
  margin-right: 4px; }

.c-emoji {
  border: none; }

</style>